export const SET_ASSIGNMENTS_LOADING = "SET_ASSIGNMENTS_LOADING";
export const SET_ASSIGNMENTS_SUBMITTING = "SET_ASSIGNMENTS_SUBMITTING";
export const SET_ASSIGNMENTS_REMOVING = "SET_ASSIGNMENTS_REMOVING";
export const SET_ASSIGNMENTS_ERROR = "SET_ASSIGNMENTS_ERROR";

export const FETCH_ASSIGNABLE_USERS_REQUEST = "FETCH_ASSIGNABLE_USERS_REQUEST";
export const FETCH_ASSIGNABLE_USERS_SUCCESS = "FETCH_ASSIGNABLE_USERS_SUCCESS";
export const FETCH_ASSIGNABLE_USERS_FAIL = "FETCH_ASSIGNABLE_USERS_FAIL";

export const FETCH_ASSIGNED_USERS_BY_EVENT_REQUEST = "FETCH_ASSIGNED_USERS_BY_EVENT_REQUEST";
export const FETCH_ASSIGNED_USERS_BY_EVENT_SUCCESS = "FETCH_ASSIGNED_USERS_BY_EVENT_SUCCESS";
export const FETCH_ASSIGNED_USERS_BY_EVENT_FAIL = "FETCH_ASSIGNED_USERS_BY_EVENT_FAIL";

export const FETCH_ASSIGNED_USERS_BY_MODULE_REQUEST = "FETCH_ASSIGNED_USERS_BY_MODULE_REQUEST";
export const FETCH_ASSIGNED_USERS_BY_MODULE_SUCCESS = "FETCH_ASSIGNED_USERS_BY_MODULE_SUCCESS";
export const FETCH_ASSIGNED_USERS_BY_MODULE_FAIL = "FETCH_ASSIGNED_USERS_BY_MODULE_FAIL";

export const BULK_ASSIGN_USERS_REQUEST = "BULK_ASSIGN_USERS_REQUEST";
export const BULK_ASSIGN_USERS_SUCCESS = "BULK_ASSIGN_USERS_SUCCESS";
export const BULK_ASSIGN_USERS_FAIL = "BULK_ASSIGN_USERS_FAIL";

export const REMOVE_ASSIGNMENT_REQUEST = "REMOVE_ASSIGNMENT_REQUEST";
export const REMOVE_ASSIGNMENT_SUCCESS = "REMOVE_ASSIGNMENT_SUCCESS";
export const REMOVE_ASSIGNMENT_FAIL = "REMOVE_ASSIGNMENT_FAIL";

export const setAssignmentsLoading = (value) => ({ type: SET_ASSIGNMENTS_LOADING, payload: value });
export const setAssignmentsSubmitting = (value) => ({ type: SET_ASSIGNMENTS_SUBMITTING, payload: value });
export const setAssignmentsRemoving = (value) => ({ type: SET_ASSIGNMENTS_REMOVING, payload: value });
export const setAssignmentsError = (error) => ({ type: SET_ASSIGNMENTS_ERROR, payload: error });

export const fetchAssignableUsersRequest = () => ({ type: FETCH_ASSIGNABLE_USERS_REQUEST });
export const fetchAssignableUsersSuccess = (users) => ({ type: FETCH_ASSIGNABLE_USERS_SUCCESS, payload: users });
export const fetchAssignableUsersFail = (error) => ({ type: FETCH_ASSIGNABLE_USERS_FAIL, payload: error });

export const fetchAssignedUsersByEventRequest = (eventId) => ({
    type: FETCH_ASSIGNED_USERS_BY_EVENT_REQUEST,
    payload: { eventId },
});
export const fetchAssignedUsersByEventSuccess = (eventId, users) => ({
    type: FETCH_ASSIGNED_USERS_BY_EVENT_SUCCESS,
    payload: { eventId, users },
});
export const fetchAssignedUsersByEventFail = (error) => ({ type: FETCH_ASSIGNED_USERS_BY_EVENT_FAIL, payload: error });

export const fetchAssignedUsersByModuleRequest = (moduleId) => ({
    type: FETCH_ASSIGNED_USERS_BY_MODULE_REQUEST,
    payload: { moduleId },
});
export const fetchAssignedUsersByModuleSuccess = (moduleId, users) => ({
    type: FETCH_ASSIGNED_USERS_BY_MODULE_SUCCESS,
    payload: { moduleId, users },
});
export const fetchAssignedUsersByModuleFail = (error) => ({ type: FETCH_ASSIGNED_USERS_BY_MODULE_FAIL, payload: error });

export const bulkAssignUsersRequest = (payload) => ({
    type: BULK_ASSIGN_USERS_REQUEST,
    payload,
});
export const bulkAssignUsersSuccess = (result, contextKey) => ({
    type: BULK_ASSIGN_USERS_SUCCESS,
    payload: { result, contextKey },
});
export const bulkAssignUsersFail = (error) => ({ type: BULK_ASSIGN_USERS_FAIL, payload: error });

export const removeAssignmentRequest = (assignmentId, context) => ({
    type: REMOVE_ASSIGNMENT_REQUEST,
    payload: { assignmentId, context },
});
export const removeAssignmentSuccess = (assignmentId) => ({
    type: REMOVE_ASSIGNMENT_SUCCESS,
    payload: assignmentId,
});
export const removeAssignmentFail = (error) => ({ type: REMOVE_ASSIGNMENT_FAIL, payload: error });
